<template>
  <div class="add-meetingbill">
    <el-container>
      <el-header style="background: white">
        <el-button
          type="text"
          @click="showPolicy"
          style="float: right; position: relative; z-index: 100"
          >查看政策说明</el-button
        >
        <el-tabs v-model="activeName">
          <el-tab-pane label="基本信息" name="first" style="min-height: 500px">
            <el-form
              ref="infoRef"
              :model="addForm"
              label-width="100px"
              :inline="true"
              :rules="paymentApply ? rules11 : rules22"
              style="text-align: left"
            >
              <!-- // 付款申请不需要这么验证，而会议提报需要 -->
              <el-row>
                <el-col :span="12">
                  <el-form-item label="提报部门：" prop="reportDepartment">
                    <el-cascader
                      v-model="addForm.reportDepartment"
                      :props="cascaderProps"
                      :placeholder="reportDepartmentName"
                      ref="cascaderRef"
                    ></el-cascader>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="汇报人：" prop="reportPerson">
                    <!-- 汇报人，点击后弹框选择，这里的input只显示名字，不允许操作。 -->
                    <el-input
                      v-model="addForm.reportPerson.name"
                      readonly
                    ></el-input>
                    <el-button @click="selectSubmitPerson" type="primary"
                      >选择</el-button
                    >
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="项目分类：" prop="projectType">
                    <el-select
                      v-model="addForm.projectType"
                      placeholder="-请选择-"
                      @change="projectTypeChange"
                    >
                      <el-option
                        v-for="option in projectTypeList"
                        :key="option.id"
                        :label="option.value"
                        :value="option.label"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item>
                    <el-button
                      type="primary"
                      @click="showTypeDesc"
                      style="margin-left: 20px"
                      >分类说明</el-button
                    >
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="会议议题：" prop="topic">
                    <el-input
                      v-model="addForm.topic"
                      placeholder="-请输入-"
                      clearable
                      maxlength="100"
                      show-word-limit
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item prop="mainContent">
                    <template slot="label">
                      <p style="display: inline-block">主要内容：</p>
                      <!-- <p>(300字以内)</p> -->
                    </template>
                    <el-input
                      type="textarea"
                      v-model="addForm.mainContent"
                      placeholder="-请输入-"
                      clearable
                      :autosize="{ minRows: 8 }"
                      maxlength="2000"
                      show-word-limit
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item
                    label="出席人："
                    prop="participanceList"
                    ref="participanceRef"
                  >
                    <div class="el-input tag-wrapper">
                      <el-tag
                        v-for="(tag, index) in addForm.participanceList"
                        @close="closeParticipance(tag)"
                        :key="index"
                        closable
                        style="margin-right: 5px"
                        >{{ tag.displayName || tag.name }}</el-tag
                      >
                    </div>
                    <el-button @click="selectParticipanceList" type="primary"
                      >选择</el-button
                    >
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item
                    label="参会部门："
                    prop="attendDepartList"
                    ref="attendDepartRef"
                  >
                    <div class="el-input tag-wrapper">
                      <el-tag
                        v-for="(tag, index) in addForm.attendDepartList"
                        @close="closeAttend(tag)"
                        :key="index"
                        closable
                        style="margin-right: 5px"
                        >{{ tag.name }}</el-tag
                      >
                    </div>
                    <el-button @click="selectAttendDepart" type="primary"
                      >选择</el-button
                    >
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="附件" name="second" style="min-height: 500px">
            <upLoadFileDialog
            :itemVOs="fileList"
            @saveUpdateFile="saveUpdateFile"
             addoredit="false"
          ></upLoadFileDialog>
          </el-tab-pane>
          <el-tab-pane
            v-if="
              addForm &&
              addForm.projectType &&
              addForm.projectType.indexOf('pay') > -1
            "
            label="付款申请"
            name="four"
            style="min-height: 500px"
          >
            <el-form
              :model="applyFormData"
              label-width="120px"
              :inline="true"
              ref="applyFormRef"
              :rules="rules1"
            >
              <el-form-item label="项目部" prop="applyDeptId">
                <el-select
                  v-model="applyFormData.applyDeptId"
                  placeholder="请选择..."
                  clearable
                  @change="applyDeptIdChange"
                >
                  <el-option
                    v-for="dept in applyDeptList"
                    :key="dept.deptId"
                    :label="dept.deptName"
                    :value="dept.deptId"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="项目名称" prop="applyProjectId">
                <el-select
                  v-model="applyFormData.applyProjectId"
                  placeholder="请选择..."
                  clearable
                  @change="applyProjectIdChange"
                >
                  <el-option
                    v-for="project in applyProjectList"
                    :key="project.projectId"
                    :label="project.projectName"
                    :value="project.projectId"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <div class="table-header-flex">
              <span>所属年度:{{ applyDetailData.belongYear }}</span>
              <span>上报日期:{{ currentApplyDate }}</span>
              <span>单位:元</span>
            </div>
            <div class="table-wrapper">
              <div v-if="applyDetailData" class="custom-table-header">
                <span class="thead-span"
                  >合同金额：{{
                    formatNumber(applyDetailData.contractAmount)
                  }}元</span
                >
                <span class="thead-span"
                  >工程收入：{{
                    formatNumber(applyDetailData.finishPriceSum)
                  }}元</span
                >
                <span class="thead-span"
                  >上报计量：{{
                    formatNumber(applyDetailData.calculatePriceSum)
                  }}元</span
                >
                <span class="thead-span"
                  >已收计量金额：{{
                    formatNumber(applyDetailData.receiptPriceSum)
                  }}元</span
                >
                <span class="thead-span"
                  >收集团拨款金额：{{
                    formatNumber(applyDetailData.groupAmount)
                  }}元</span
                >
              </div>
              <el-table
                :data="applyDetailTableData"
                border
                style="width: 100%"
                :span-method="arraySpanMethod"
              >
                <el-table-column
                  type="index"
                  label="序号"
                  fixed
                ></el-table-column>
                <el-table-column
                  prop="columnTitle"
                  label="项目"
                  width="150"
                  fixed
                ></el-table-column>
                <el-table-column
                  prop="partyB"
                  label="合作单位"
                  width="200"
                ></el-table-column>
                <el-table-column
                  prop="serialNumber"
                  label="合同编号"
                  width="200"
                >
                  <template slot-scope="scope">
                    <!-- <div
                      slot="content"
                      v-if="Array.isArray(scope.row.serialNumber)"
                    >
                      <p
                        v-for="item in scope.row.serialNumber"
                        :key="item"
                        style="margin-bottom: 0;min-width: 200px;"
                      >
                        {{ item }}
                      </p>
                    </div>
                    <div v-else>
                      <p style="margin-bottom: 0;min-width: 200px;">
                        {{ scope.row.serialNumber }}
                      </p>
                    </div> -->

                    <div class="number-list-wrapper">
                      {{ formatSerialNumber(scope.row.serialNumber) }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="contractContent"
                  label="合同内容"
                  width="200"
                ></el-table-column>
                <el-table-column label="税后合价" width="200">
                  <template slot-scope="scope">
                    <div>{{ formatNumber(scope.row.settleAmount) }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="累计已付款" width="200">
                  <template slot-scope="scope">
                    <div>{{ formatNumber(scope.row.alreadyPay) }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="尚欠款" width="200">
                  <template slot-scope="scope">
                    <div>{{ formatNumber(scope.row.debtAmount) }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="已付款比例" width="200">
                  <template slot-scope="scope">
                    <div>{{ formatPercent(scope.row.alreadyPayPct) }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="本次拟付款" width="200">
                  <template slot-scope="scope">
                    <div>{{ formatNumber(scope.row.thisPay) }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="再付款比例" width="200">
                  <template slot-scope="scope">
                    <div>{{ formatPercent(scope.row.thisPayPct) }}</div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="remark"
                  label="备注"
                  width="200"
                ></el-table-column>
              </el-table>
            </div>
          </el-tab-pane>
          <el-tab-pane label="审批流程" name="third" style="min-height: 500px">
            <newApproveLine
            :addoredit="editFlag"
            :itemId="0"
            @saveApproveLine="saveApproveLine"
            @saveApproveType="saveApproveType"
            :approveType="approveType"
            :approveClass="approveClass"
            :subApproveType="addForm.approveTemplateType || 'meetingbill'"
            :subApproveName="addForm.approveTemplateName || ''"
          ></newApproveLine>
          
          </el-tab-pane>
          <div class="tabs-footer">
            <el-button type="primary" @click.stop="doSubmit(true)"
              >暂存</el-button
            >
            <el-button type="primary" @click.stop="doSubmit(false)"
              >提交</el-button
            >
            <el-button @click="closePageHandler" type="info">取消</el-button>
          </div>
        </el-tabs>
      </el-header>
    </el-container>
    <select-dialog
      :visible="selectDialogVisible"
      @close="selectDialogClose"
      title="选择"
      v-bind="selectDialogOptions"
    />
    <el-dialog title="分类说明" :visible.sync="typeDescVisible">
      <div v-html="typeDescStr"></div>
      <div slot="footer" style="text-align: center">
        <el-button type="primary" @click="typeDescVisible = false"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog title="政策说明" :visible.sync="policyVisible">
      <div v-html="policyStr"></div>
      <div slot="footer" style="text-align: center">
        <el-button type="primary" @click="policyVisible = false"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Consts from "@/utils/consts";
import {
  getOrgIdService,
  getDeptListService,
  getRuleDetailService,
} from "@/services/sysSettingService";
import { getSubService, getDeptCheck } from "@/services/departService";
import { getDefaultGroupApi } from "@/services/groupService";
import SelectDialog from "./SelectDialog";
import { formatMoney, formatPercent } from "../../finance/utils";
import newApproveLine from "@/page/approveComponents/NewApproveLine"; //新增审批流程
import upLoadFileDialog from "@/components/upLoadFileDialog"; //上传附件

import {
  getProjectTypeList,
  addNewDeclaration,
  createApproveProcessService,
} from "@/services/declarationServices";
import {
  queryPayRequestInfoApi,
  earningCostqueryDeptListApi,
  earningCostqueryProjectListAPi,
} from "@/services/financeService";
export default {
  name: "AddMeetingBill",
  components: {
    SelectDialog,
    upLoadFileDialog,
    newApproveLine,
  },
  data() {
    let validateReportPerson = (rule, value, callback) => {
      if (!value || !value.id) {
        return callback(new Error("汇报人不得为空"));
      }
      callback();
    };
    return {
      editFlag:false,
      approveType:'meetingbill',
      approveClass: "DECLARATION",
      typeDescVisible: false,
      typeDescStr: "",
      policyVisible: false,
      policyStr: "",
      activeName: "first", //活动tab页
      reportDepartmentName: "",
      addForm: {
        reportDepartment: null, // 提报部门
        projectType: null, // 项目分类
        topic: "", // 会议议题
        mainContent: "", // 会议主要内容
        reportPerson: {
          // 汇报人信息
          id: undefined,
          name: "",
        },
        attendDepartList: [], // 参会部门
        participanceList: [],
      },
      projectTypeList: [],
      rules1: {
        applyDeptId: [
          { required: true, message: "请选择项目部", trigger: "change" },
        ],
        applyProjectId: [
          { required: true, message: "请选择项目名称", trigger: "change" },
        ],
      },
      rules11: {
        reportDepartment: [
          {
            required: true,
            message: "请选择提报部门",
            trigger: ["blur"],
          },
        ],
        reportPerson: [
          {
            required: true,
            validator: validateReportPerson,
            trigger: ["change"],
          },
        ],
        projectType: [
          {
            required: true,
            message: "请选择项目分类",
            trigger: ["blur", "change"],
          },
        ],
      },
      rules22: {
        reportDepartment: [
          {
            required: true,
            message: "请选择提报部门",
            trigger: ["blur", "change"],
          },
        ],
        reportPerson: [
          {
            required: true,
            validator: validateReportPerson,
            trigger: ["change"],
          },
        ],
        projectType: [
          {
            required: true,
            message: "请选择项目分类",
            trigger: ["blur", "change"],
          },
        ],
        topic: [{ required: true, message: "请输入会议议题", trigger: "blur" }],
        mainContent: [
          { required: true, message: "请输入主要内容", trigger: "blur" },
        ],
        participanceList: [
          {
            type: "array",
            required: true,
            message: "请选择出席人",
            trigger: "change",
          },
        ],
        attendDepartList: [
          {
            type: "array",
            required: true,
            message: "请选择参会部门",
            trigger: "change",
          },
        ],
      },
      cascaderProps: {
        // 提报部门的选择
        checkStrictly: true,
        lazy: true,
        label: "name",
        value: "id",
        lazyLoad: (node, resolve) => {
          //  在这个加载方法里处理error，如果想用vue的this绑定，必须用箭头函数保持this指向。用function的写法会重新绑定this指向
          let { level } = node;

          if (level == 0) {
            // 第1级，用当前人的orgId去获取组织下的部门列表
            getDeptListService({
              pid: 0,
              orgId: sessionStorage.getItem("orgId"), // 它这套打开的逻辑打乱了原有的生命周期，执行顺序，调用lazyLoad时还没有调用onActive
            })
              .then((res) => {
                if (res.code == Consts.Code_OK) {
                  let nodes = res.data || [];
                  nodes.forEach((node) => {
                    node.leaf = node.isLeaf == 1;
                  });
                  return resolve(nodes);
                } else if (res.code >= Consts.Code_Err) {
                  this.$alert(res.msg, "提示", {
                    confirmButtonText: "确定",
                  });
                } else {
                  this.$message.error(res.Msg);
                  resolve([]);
                }
              })
              .catch((error) => {
                this.$message.error(Consts.Err_Msg);
                resolve([]);
              });
          } else {
            // 用选择的node去获取对应的子部门
            getSubService({
              deptId: node.data.id,
            })
              .then((res) => {
                if (res.code == Consts.Code_OK) {
                  let nodes = res.data || [];
                  nodes.forEach((node) => {
                    node.leaf = node.isLeaf == 1;
                  });
                  return resolve(nodes);
                } else if (res.code >= Consts.Code_Err) {
                  this.$alert(res.msg, "提示", {
                    confirmButtonText: "确定",
                  });
                } else {
                  this.$message.error(res.Msg);
                  resolve([]);
                }
              })
              .catch((error) => {
                this.$message.error(Consts.Err_Msg);
                resolve([]);
              });
          }
        },
      },

      selectDialogVisible: false,
      selectDialogOptions: {
        departOn: true,
        groupOn: true,
        canSelectDepart: false,
        canSelectUser: true,
        canSelectGroup: false,
        maxSelectedItem: 1,
        dataKey: "reportPerson",
        canSelectAll: true,
      },
      fileList: [], // 附件列表
      approveList: [], // 审批流列表
      applyDeptList: [], // 供创建付款申请用的接口返回的备选项
      applyFormData: {}, // 付款申请表单
      applyProjectList: [],
      applyDetailData: {},
      applyDetailTableData: [],
      currentApplyDate: "",
      paymentApply: false, // 是否是付款申请
      defaultGroupInfo: {}, // 默认群组信息
    };
  },
  watch: {
    "addForm.reportDepartment": function (newValue) {
      if (newValue && newValue.length != 0) {
        // 有确定的部门
        let dept = newValue[newValue.length - 1];
        getDeptCheck({ deptId: dept })
          .then((res) => {
            if (res.code == Consts.Code_OK) {
              // console.log('123', res.data);
              if (
                res.data.responseUserList &&
                res.data.responseUserList.length
              ) {
                let head = res.data.responseUserList[0];
                this.addForm.reportPerson.id = head.id;
                this.addForm.reportPerson.name = head.displayName || head.name;
              } else {
                // 没有部门负责人
                console.log("没有部门负责人");
                this.addForm.reportPerson.id = undefined;
                this.addForm.reportPerson.name = "";
              }
            } else {
              console.log(res.msg);
              this.addForm.reportPerson.id = undefined;
              this.addForm.reportPerson.name = "";
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        // 没有确定的部门，要清空选定的汇报人
        this.addForm.reportPerson.id = undefined;
        this.addForm.reportPerson.name = "";
      }
    },
  },
  methods: {
    //存储审批流模板类型
    saveApproveType(item) {
      this.addForm.approveTemplateType = item.label;
      this.addForm.approveTemplateName = item.value;
    },
    //存储审批流
    saveApproveLine(selectItems) {
      this.approveList = selectItems;
    },
    formatSerialNumber(serialNumber) {
      if (!serialNumber) {
        return "";
      }
      if (Array.isArray(serialNumber)) {
        return serialNumber.join("、");
      }
      return serialNumber;
    },
    // 表格合并计算方法
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      // || columnIndex == 3
      if (columnIndex == 1) {
        const {
          serviceCostAnalysis = [],
          materialCostAnalysis = [],
          machineCostAnalysis = [],
          otherDirectCostAnalysis = [],
        } = this.applyDetailData;
        if (row.columnTitle == "劳务费") {
          let index = serviceCostAnalysis.indexOf(row);
          if (index == 0) {
            return {
              rowspan: serviceCostAnalysis.length,
              colspan: 1,
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0,
            };
          }
        } else if (row.columnTitle == "材料费") {
          let index = materialCostAnalysis.indexOf(row);
          if (index == 0) {
            return {
              rowspan: materialCostAnalysis.length,
              colspan: 1,
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0,
            };
          }
        } else if (row.columnTitle == "机械费") {
          let index = machineCostAnalysis.indexOf(row);
          if (index == 0) {
            return {
              rowspan: machineCostAnalysis.length,
              colspan: 1,
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0,
            };
          }
        } else if (row.columnTitle == "其他直接费") {
          let index = otherDirectCostAnalysis.indexOf(row);
          if (index == 0) {
            return {
              rowspan: otherDirectCostAnalysis.length,
              colspan: 1,
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0,
            };
          }
        }
      }
    },
    showPolicy() {
      this.policyVisible = true;
    },

    showTypeDesc() {
      this.typeDescVisible = true;
    },
    onActive(menuCode) {
      let params = this.tabRouteParam || {};
      this.paymentApply = params.paymentApply || false;
      setTimeout(() => {
        this.$refs.infoRef.clearValidate();
      }, 0);
      this.initProjectTypeList();
      this.initTypeDesc();
      this.initPolicy();
      this.initReportDepartment(); // 初始化时默认选择当前用户所在的部门作为提报部门，然后选这个部门的负责人
      this.initearningCostqueryDeptList();
      this.getDefaultGroup();
      let date = new Date();
      this.currentApplyDate = [
        date.getFullYear(),
        date.getMonth() + 1,
        date.getDate(),
      ]
        .map((value) => (value >= 10 ? value : "0" + value))
        .join("-");
    },

    // 出席人里默认带“领导班子”，“领导班子”这个群组是从系统里设置成默认的，也可以是其他的群组，只要它射程默认的就可以，所以要去后台获取默认的放在这
    getDefaultGroup() {
      console.log("getDefaultGroup getDefaultGroup getDefaultGroup");
      let orgId = sessionStorage.getItem("orgId");
      getDefaultGroupApi({
        orgId,
      })
        .then((res) => {
          if (res.code == Consts.Code_OK) {
            console.log("默认群组", res.data);
            this.defaultGroupInfo = res.data;
            this.addForm.participanceList = [
              {
                id: res.data.id,
                name: res.data.name,
                isDefault: true,
                meetingType: "group",
              },
            ];
          }
        })
        .catch(() => {});
    },

    initearningCostqueryDeptList() {
      console.log("获取可供选择的项目部");
      earningCostqueryDeptListApi()
        .then((res) => {
          if (res.code == Consts.Code_OK) {
            this.applyDeptList = res.data || [];
            console.log("applyDeptList", this.applyDeptList);
          }
        })
        .catch(() => {});
    },
    initReportDepartment() {
      let userId = sessionStorage.getItem("currentUserId");
      let reqParam = {
        userId: userId,
      };
      getOrgIdService(reqParam)
        .then((res) => {
          if (res.code == Consts.Code_OK) {
            /**
           * 如果当前用户所在的部门正好是一级部门，那么设置reportDepartment，cascader会显示有对应的部门，因为
          一开始就会获取一级列表。如果不是一级部门，那么此时cascader的一级部门跟默认部门之间就没法对应，就会显示
          成placeholder
           */
            this.reportDepartmentName = res.data.deptDisplayName; // 用cascader的placeholder显示默认
            this.addForm.reportDepartment = [res.data.deptId]; // 这里设置是为了获取后面的负责人的
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    initPolicy() {
      let businessType = "0003";
      getRuleDetailService(businessType)
        .then((res) => {
          if (res.code == Consts.Code_OK) {
            this.policyStr = res.data.typeExplain;
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((error) => {
          this.$message.error("系统异常");
        });
    },

    initTypeDesc() {
      let businessType = "0004";
      getRuleDetailService(businessType)
        .then((res) => {
          if (res.code == Consts.Code_OK) {
            this.typeDescStr = res.data.typeExplain;
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((error) => {
          this.$message.error("系统异常");
        });
    },

    initProjectTypeList() {
      getProjectTypeList()
        .then((res) => {
          if (res.code == Consts.Code_OK) {
            //this.projectTypeList = res.data || [];
            if (res.data && res.data.length > 0) {
              if (this.paymentApply) {
                //付款申请页面，只显示工程款支付类型的项目分类，判断条件：label是否包含特征码'pay'
                this.projectTypeList = [];
                res.data.forEach((element) => {
                  if (element.label.indexOf("pay") > -1) {
                    this.projectTypeList.push(element);
                  }
                });

                this.addForm.projectType = this.projectTypeList[0].label; //默认用第一个赋值
              } else {
                this.projectTypeList = res.data;
              }
            } else {
              this.$alert(
                "尚未配置项目分类，请联系管理员，完成配置后重试！",
                "提示",
                {
                  confirmButtonText: "确定",
                }
              );
            }
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((error) => {
          this.$message.error(Consts.Err_Msg);
        });
    },

    projectTypeChange(type) {
      console.log("当前选中的项目分类:", type);
      // 清空已经选的审批流数据
      // this.approveList = [];
    },

    doSubmit(val) {
      // 最后提交创建提报单
      let infoPromise = new Promise((resolve, reject) => {
        this.$refs.infoRef.validate((valid) => {
          if (valid == false) {
            reject(false);
          } else {
            resolve(true);
          }
        });
      });

      let approvePromise = new Promise((resolve, reject) => {
        let pass = true;
        if (this.approveList.length == 0 && !val) {
          // 如果approveList长度是0，那代表还没有选定项目类型，从而获取审批流
          this.$message.warning("请配置审批流程");
          reject(false);
        }
        for (let i = 0; i < this.approveList.length; i++) {
          if (!!this.approveList[i].approveUserId == false) {
            // 还没选定人
            pass = false;
            break;
          }
        }

        if (pass == false && !val) {
          this.$message.warning("请配置审批流程");
          reject(false);
        } else {
          resolve(true);
        }
      });

      Promise.all([approvePromise, infoPromise])
        .then(() => {
          let { reportDepartment } = this.addForm;
          let deptId =
            reportDepartment && reportDepartment.length > 0
              ? reportDepartment[reportDepartment.length - 1]
              : null;

          let deptName = this.reportDepartmentName;
          let checkedNodes = this.$refs.cascaderRef.getCheckedNodes(true);
          try {
            let node = checkedNodes[checkedNodes.length - 1];
            deptName = node.pathLabels[node.pathLabels.length - 1];
          } catch (error) {
            console.log(error);
          }

          let params = {
            isTempSave: val,
            checkWorkJson: JSON.stringify(this.addForm.attendDepartList), // 参会部门
            content: this.addForm.mainContent, // 主要内容
            declarationItemsVOs: this.fileList, // 附件列表
            deptId: deptId, // 提报部门
            deptName: deptName,
            joinWorkJson: JSON.stringify(this.addForm.participanceList), // 出席人
            projectType: this.addForm.projectType, // 项目分类
            reportUserId: this.addForm.reportPerson.id, // 汇报人id
            title: this.addForm.topic, // 会议议题
            approveTemplateType: this.addForm.approveTemplateType,
            approveTemplateName: this.addForm.approveTemplateName,
          };

          return params;
          // return addNewDeclaration(params);
        })
        .then((params) => {
          console.log("项目分类", params.projectType);
          if (params.projectType.indexOf("pay") == -1) {
            return addNewDeclaration(params);
          }
          // 是工程款支付类型
          console.log("是工程款支付类型");
          if (
            !this.applyFormData ||
            !this.applyFormData.applyDeptId ||
            !this.applyFormData.applyProjectId
          ) {
            this.$message.warning("请设置付款申请信息");
            return Promise.reject("请设置付款申请信息");
          }

          params.projectDeptId = this.applyFormData.applyDeptId;
          params.projectId = this.applyFormData.applyProjectId;
          return addNewDeclaration(params);
        })
        .then((res) => {
          if (res.code == Consts.Code_OK) {
            // console.log("--------创建会议提报完了", res);
            const itemId = res.data;
            // 【提交人】关于【部门】【会议主题】的【审批流类型】申请
            // 【提交人】关于【所属年度】【合作单位】的【审批流类型】申请
            if (val) {
              this.tempSaveContent(itemId);
              return;
            }

            let itemName = "";
            if (this.addForm.projectType.indexOf("pay") == -1) {
              // 普通的会议提报
              let deptName = this.reportDepartmentName;
              try {
                let checkedNodes = this.$refs.cascaderRef.getCheckedNodes(true);
                let node = checkedNodes[checkedNodes.length - 1];
                deptName = node.pathLabels[node.pathLabels.length - 1];
              } catch (error) {
                console.log(error);
              }

              itemName = `${sessionStorage.getItem("name")}关于${deptName}${
                this.addForm.topic
              }的${this.addForm.approveTemplateName ? this.addForm.approveTemplateName : "会议提报"}申请`;
            } else {
              // 付款申请
              let danwei = new Set();
              let tableData = this.applyDetailTableData || [];
              for (let i = 0; i < tableData.length; i++) {
                danwei.add(tableData[i].partyB);
              }
              danwei = Array.from(danwei);
              danwei = danwei.join("、");
              itemName = `${sessionStorage.getItem("name")}关于${
                this.applyDetailData.belongYear
              }${danwei}的${this.addForm.approveTemplateName ? this.addForm.approveTemplateName : "工程款支付"}申请`;
            }

            let params = {
              approveClass: "DECLARATION",
              approveProcessDtoList: this.approveList,
              itemId: itemId,
              approveStatusEnum: "UNDERAPLLY",
              itemName: itemName,
              projectId: this.applyFormData
                ? this.applyFormData.applyProjectId
                : null,
            };

            createApproveProcessService(params).then((res) => {
              if (res.code == Consts.Code_OK) {
                this.$alert(Consts.Add_OK_Msg, "提示");
                this.closePage();
              } else if (res.code == Consts.Code_Err) {
                this.$alert(res.msg, "提示");
              } else {
                this.$alert(Consts.Err_Msg, "提示");
              }
            });
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //暂存审批流
    tempSaveContent(itemId) {
      if (this.approveList.length == 0) {
        this.$message.success("保存成功", "提示");
        // 如果approveList长度是0，那代表还没有选定项目类型，暂存不保存审批流
        this.closePage();
        return
      }
      let pass=true;
      for (let i = 0; i < this.approveList.length; i++) {
        if (!this.approveList[i].approveUserId) {
          // 还没选定人
          pass = false;
          break;
        }
      }
      //未选择审批人，不保存审批流
      if (pass == false) {
        this.$message.success("保存成功", "提示");
        this.closePage();
        return
      }
      let itemName = "";
      if (this.addForm.projectType.indexOf("pay") == -1) {
        // 普通的会议提报
        let deptName = this.reportDepartmentName;
        try {
          let checkedNodes = this.$refs.cascaderRef.getCheckedNodes(true);
          let node = checkedNodes[checkedNodes.length - 1];
          deptName = node.pathLabels[node.pathLabels.length - 1];
        } catch (error) {
          console.log(error);
        }

        itemName = `${sessionStorage.getItem("name")}关于${deptName}${
          this.addForm.topic
        }的${this.addForm.approveTemplateName ?this.addForm.approveTemplateName : "会议提报"}申请`;
      } else {
        // 付款申请
        let danwei = new Set();
        let tableData = this.applyDetailTableData || [];
        for (let i = 0; i < tableData.length; i++) {
          danwei.add(tableData[i].partyB);
        }
        danwei = Array.from(danwei);
        danwei = danwei.join("、");
        itemName = `${sessionStorage.getItem("name")}关于${
          this.applyDetailData.belongYear
        }${danwei}的${this.addForm.approveTemplateName ? this.addForm.approveTemplateName : "工程款支付"}申请`;
      }

      let params = {
        approveClass: "DECLARATION",
        approveProcessDtoList: this.approveList,
        itemId: itemId,
        approveStatusEnum: "READY",
        itemName: itemName,
        projectId: this.applyFormData
          ? this.applyFormData.applyProjectId
          : null,
      };

      createApproveProcessService(params).then((res) => {
        if (res.code == Consts.Code_OK) {
          this.$message.success("保存成功", "提示");
          this.closePage();
        } else if (res.code == Consts.Code_Err) {
          this.$alert(res.msg, "提示");
        } else {
          this.$alert(Consts.Err_Msg, "提示");
        }
      });
    },

    closePage() {
      if (this.paymentApply) {
        this.bus.$emit("tabClose", "createPaymentApply");
        this.bus.$emit("navMenuChange", {
          routeId: "paymentApplyList",
        });
      } else {
        this.bus.$emit("tabClose", "createMeetingBill");
        this.bus.$emit("navMenuChange", {
          routeId: "meetingList",
        });
      }
    },
    closePageHandler() {
      this.$confirm("您确定要取消吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.closePage();
        })
        .catch(() => {});
    },

    selectSubmitPerson() {
      // 选择汇报人
      this.selectDialogOptions = {
        departOn: true,
        groupOn: true,
        canSelectDepart: false,
        canSelectUser: true,
        canSelectGroup: false,
        maxSelectedItem: 1,
        dataKey: "reportPerson",
        canSelectAll: false,
      };
      this.selectDialogVisible = true;
    },
    selectParticipanceList() {
      // 选择出席人.可以选择个人，可以选择群组，不可以选择部门
      this.selectDialogOptions = {
        departOn: true,
        groupOn: true,
        canSelectDepart: false,
        canSelectUser: true,
        canSelectGroup: true,
        maxSelectedItem: 0,
        dataKey: "participance",
      };
      this.selectDialogVisible = true;
    },
    selectAttendDepart() {
      // 选择参会部门
      this.selectDialogOptions = {
        departOn: true,
        groupOn: false,
        canSelectDepart: true,
        canSelectUser: false,
        canSelectGroup: false,
        maxSelectedItem: 0,
        dataKey: "attendDepart",
      };
      this.selectDialogVisible = true;
    },
    closeParticipance(tag) {
      // 删除出席人
      let index = this.addForm.participanceList.indexOf(tag);
      if (index != -1) {
        this.addForm.participanceList.splice(index, 1);
      }
    },
    closeAttend(tag) {
      // 删除参会部门
      let index = this.addForm.attendDepartList.indexOf(tag);
      if (index != -1) {
        this.addForm.attendDepartList.splice(index, 1);
      }
    },
    selectDialogClose(data) {
      console.log("111 selectDialogClose ----", data);
      this.selectDialogVisible = false;
      const { dataKey } = data;
      switch (dataKey) {
        case "reportPerson": // 汇报人
          if (data.userList && data.userList.length > 0) {
            let item = data.userList[0];
            this.addForm.reportPerson = item;
            this.addForm.reportPerson.name = item.displayName || item.name;
          }
          break;
        case "attendDepart": // 参会部门
          // eslint-disable-next-line
          let departList = data.departList || [];
          departList.forEach((o) => {
            let index = this.addForm.attendDepartList.findIndex(
              (p) => p.id == o.id
            );
            if (index == -1) {
              this.addForm.attendDepartList.push(o);
            }
          });
          this.$refs.attendDepartRef.$emit(
            "el.form.change",
            this.addForm.attendDepartList
          );
          break;
        case "participance": // 出席人
          // eslint-disable-next-line
          let userList = data.userList || [];
          // eslint-disable-next-line
          let groupList = data.groupList || [];
          userList.forEach((user) => {
            user.meetingType = "user";
          });
          groupList.forEach((group) => {
            group.meetingType = "group";
          });
          // eslint-disable-next-line
          let list = userList.concat(groupList);
          list.forEach((o) => {
            let index = this.addForm.participanceList.findIndex(
              (p) => p.meetingType == o.meetingType && p.id == o.id
            );
            if (index == -1) {
              this.addForm.participanceList.push(o);
            }
          });
          this.$refs.participanceRef.$emit(
            "el.form.change",
            this.addForm.participanceList
          );
          break;

        default:
          break;
      }
    },

    selectApprovePerson(item) {},
    selectLeaderPerson(item) {},

    //存储附件
    saveUpdateFile(selectItems) {
      this.fileList = selectItems
    },
    applyDeptIdChange(value) {
      console.log("----", value, this.applyFormData.applyDeptId);
      //项目部变了之后，能选的项目名称也要变，所以要重新调用接口
      this.applyFormData.applyProjectId = undefined;
      this.applyDetailData = {};
      this.applyDetailTableData = [];
      this.earningCostqueryProjectList();
    },
    earningCostqueryProjectList() {
      console.log("获取选定项目部下的项目");
      if (this.applyFormData.applyDeptId) {
        earningCostqueryProjectListAPi({
          deptId: this.applyFormData.applyDeptId,
        })
          .then((res) => {
            if (res.code == Consts.Code_OK) {
              this.applyProjectList = res.data || [];
              console.log("applyProjectList", this.applyProjectList);
            }
          })
          .catch(() => {});
      }
    },
    applyProjectIdChange() {
      if (!this.applyFormData.applyProjectId) {
        return;
      }
      queryPayRequestInfoApi({
        projectId: this.applyFormData.applyProjectId,
      })
        .then((res) => {
          if (res.code == Consts.Code_OK) {
            this.applyDetailData = res.data || {};

            const {
              serviceCostAnalysis = [],
              materialCostAnalysis = [],
              machineCostAnalysis = [],
              otherDirectCostAnalysis = [],
            } = this.applyDetailData;

            serviceCostAnalysis.forEach((item) => {
              item.columnTitle = "劳务费";
            });
            materialCostAnalysis.forEach((item) => {
              item.columnTitle = "材料费";
            });
            machineCostAnalysis.forEach((item) => {
              item.columnTitle = "机械费";
            });
            otherDirectCostAnalysis.forEach((item) => {
              item.columnTitle = "其他直接费";
            });

            let tableData = []
              .concat(serviceCostAnalysis)
              .concat(materialCostAnalysis)
              .concat(machineCostAnalysis)
              .concat(otherDirectCostAnalysis);

            this.applyDetailTableData = tableData;
            console.log("--table list", this.applyDetailTableData);
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch((error) => {
          this.$alert(error.message, "提示");
        });
    },
    formatNumber: formatMoney,
    formatPercent: formatPercent,
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/commonLayout.scss";
.add-meetingbill {
  height: 100%;
  /deep/.el-select {
    width: 600px;
  }
}

.el-tab-pane {
  margin-top: 20px;
}

/deep/ .el-tabs__item {
  padding: 0 20px !important;
}
/deep/ .el-tabs__header {
  padding-right: 0px !important;
}

/deep/ .el-form-item__content {
  display: flex;

  .el-input {
    flex: 1;
  }

  .el-button {
    margin-left: 10px;
    height: fit-content;
  }
}

.tag-wrapper {
  border: 1px solid #dcdfe6;
  padding: 0 5px;
}

.tabs-footer {
  text-align: center;
  padding: 50px 0 20px;
}

.thead-span {
  margin-right: 20px;
}

table {
  width: 100%;
}

.table-header-flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
}

.custom-table-header {
  position: relative;
  width: 100%;
  padding: 20px 10px;
  background: #edf8fa;
  border-bottom: 1px solid #ebeef5;

  .thead-span {
    margin-right: 20px;
  }
}

// .number-list-wrapper {
//   overflow: hidden;
//   text-overflow: ellipsis;
//   white-space: nowrap;
// }
</style>
